import $ from 'jquery';
import apiFetch from '@wordpress/api-fetch';
import BaseSettings from './base-settings';
import {registerSettings} from "./register";

class ApplepaySettings extends BaseSettings {

    constructor(props) {
        super(props);
        $(document.body).on('click', '.button-domain-association', this.createDomainAssociationFile.bind(this));
    }

    async createDomainAssociationFile(e) {
        e.preventDefault();
        const $button = $(e.currentTarget);
        const text = $button.text();
        try {
            $button.prop('disabled', true).text(this.data.i18n.processing);
            const response = await apiFetch({
                method: 'POST',
                url: this.getAjaxPath('/wc-ppcp/v1/admin/domain-association-file')
            });
            alert(response.message);
        } catch (error) {
            alert(this.data.i18n.file_error + ' ' + error.message);
        } finally {
            $button.prop('disabled', false).text(text);
        }
    }

}

registerSettings('ppcp_applepay', ApplepaySettings);